import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { PopupStore } from '@gem/popups';
import { Divider, IconView, MenuItem } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { WorkspaceAvatar } from 'APP/components/Avatar/WorkspaceAvatar/WorkspaceAvatar';

import { ProfileDescription } from '../components/ProfileDescription/ProfileDescription';
import { WorkspaceRegion } from '../components/WorkspaceRegion/WorkspaceRegion';
import { useWorkspaceProfilePresenter } from './WorkspaceProfile.presenter';
import styles from './WorkspaceProfile.styles.m.css';

interface IWorkspaceProfile {
  className?: string;
  metaBlockClassName?: string;
  popupInstance: PopupStore;
}

export const WorkspaceProfile: FC<IWorkspaceProfile> = observer(
  ({ className, metaBlockClassName, popupInstance }) => {
    const { t } = useTranslation();
    const presenter = useWorkspaceProfilePresenter(popupInstance);

    return (
      <div className={className}>
        <div className={styles.header}>
          <WorkspaceAvatar
            type={AvatarTypes.Square_40}
            withFullScreen
            className={styles.avatar}
          />

          <div className={styles.info}>
            <h3 className={styles.title}>{presenter.workspace.name}</h3>
            <div className={styles.members}>
              {t('org_members_universal', { 0: presenter.workspace.membersCount })}
            </div>
          </div>
        </div>

        <Divider theme="style1" />

        <ProfileDescription
          className={classNames(styles.contact, metaBlockClassName)}
          description={presenter.workspace.description}
        />

        {presenter.workspace.region && (
          <WorkspaceRegion
            className={classNames(styles.contact, metaBlockClassName)}
            region={presenter.workspace.region}
          />
        )}

        <Divider theme="style1" />

        {presenter.menuItems.map((menuItem) => (
          <MenuItem
            key={menuItem.key}
            className={styles.listItem}
            title={menuItem.title}
            count={menuItem.count}
            icon={
              <IconView
                Icon={menuItem.Icon}
                className={styles.listIcon}
              />
            }
            onClick={menuItem.onClick}
          />
        ))}
      </div>
    );
  }
);
